import { useEffect, useState } from "react";
import { http } from "@/lib/api";

export function useCollection(name) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    http.get(`/${name}`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [name]);
  return items;
}

export function useItem(name, id) {
  const [item, setItem] = useState(undefined);
  useEffect(() => {
    setItem(undefined);
    http.get(`/${name}/${id}`).then((r) => setItem(r.data)).catch(() => setItem(null));
  }, [name, id]);
  return item;
}

const SITE_URL = "https://www.greywolfeng.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const setMeta = (selector, content) => {
  const el = document.head.querySelector(selector);
  if (el && content) el.setAttribute(el.tagName === "LINK" ? "href" : "content", content);
};

// Per-route title, description, canonical and share tags (crawlers with prerender read these).
export function usePageMeta(title, description, image) {
  useEffect(() => {
    document.title = title;
    const url = `${SITE_URL}${window.location.pathname === "/" ? "/" : window.location.pathname.replace(/\/$/, "")}`;
    const img = image && image.startsWith("http") ? image : DEFAULT_IMAGE;
    setMeta('meta[name="description"]', description);
    setMeta('link[rel="canonical"]', url);
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[name="twitter:description"]', description);
    setMeta('meta[property="og:image"]', img);
    setMeta('meta[name="twitter:image"]', img);
    window.scrollTo(0, 0);
  }, [title, description, image]);
}
